const STORAGE_KEY = "invoice-manager-theme";
const THEME_CHANGE_EVENT = "invoice-manager-theme-change";

function applyTheme(isDark) {
  document.documentElement.classList.toggle("dark", isDark);
  document.documentElement.style.colorScheme = isDark ? "dark" : "light";
}

export function getStoredTheme() {
  if (typeof window === "undefined") return "light";
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === "dark" ? "dark" : "light";
}

export function setStoredTheme(theme) {
  const next = theme === "dark" ? "dark" : "light";
  localStorage.setItem(STORAGE_KEY, next);
  applyTheme(next === "dark");
  window.dispatchEvent(new Event(THEME_CHANGE_EVENT));
  return next;
}

export function initTheme() {
  applyTheme(getStoredTheme() === "dark");
}

export function subscribeTheme(onStoreChange) {
  const handler = () => onStoreChange();
  window.addEventListener(THEME_CHANGE_EVENT, handler);
  return () => window.removeEventListener(THEME_CHANGE_EVENT, handler);
}

export function getThemeSnapshot() {
  return getStoredTheme();
}

export function getThemeServerSnapshot() {
  return "light";
}
